import React from 'react'
import VendNumber, { vn } from 'vend-number'
import {
  Modal,
  ModalHeader,
  ModalActions,
  Button,
} from '@lightspeed/design-system-react'
import { RoundedNumber } from '../../CashPaymentModal'
import { useVdCurrencyFilter } from '../../../../../ng-compat/hooks'

interface RefundProps {
  amountToPay: RoundedNumber
  isPartialPayment: boolean
  closeWithoutPayment: () => void
  pay: (paid: VendNumber) => void
}

export const Refund: React.FC<RefundProps> = ({
  amountToPay: { rounded },
  isPartialPayment,
  closeWithoutPayment,
  pay,
}) => {
  const vdCurrencyFilter = useVdCurrencyFilter()

  return (
    <Modal size="medium" dismissable onClose={() => closeWithoutPayment()}>
      <ModalHeader>
        <div className="vd-text-grand vd-align-center">
          Refund {vdCurrencyFilter(-vn(rounded).toNumber())}
        </div>
      </ModalHeader>
      <ModalActions>
        <Button block jumbo onClick={() => pay(vn(rounded))} variant="no">
          Complete {isPartialPayment ? 'Partial ' : ''}Refund
        </Button>
      </ModalActions>
    </Modal>
  )
}
